// extracted by mini-css-extract-plugin
export default {"final-buttons":"EntryForm_final-buttons__n-XZb","card-item":"EntryForm_card-item__RLDiv"};